import http from './http'
const baseUrl = process.env.REACT_APP_QUESTION_ANSWER_AI_URL
export const generateQuestContent = (payload) => {
    return http({
        method: 'POST',
        data: payload,
        url: `${baseUrl}/generate?service=treasure-hunt`
    })
}

export const getQuestContent = (params) => {
    return http({
        method: 'GET',
        url: `${baseUrl}/hunts?service=treasure-hunt&user_id=${params.user_id}&org_id=${params.org_id}&limit=${params.limit}&offset=${params.offset}${params.search ? `&search=${params.search}` : ''}${params.parent_treasure_hunt ? `&parent_treasure_hunt=true` : ''}`
    })
}
export const generateStopsVideo = (location_id) => {
    return http({
        method: 'POST',
        url: `${baseUrl}/generate-video/${location_id}?service=treasure-hunt-location`
    })
}
export const generateLocationAction = (payload) => {
    return http({
        method: 'POST',
        data: payload,
        url: `${baseUrl}/generate?service=treasure-hunt-location`
    })
}
export const processLocationAction = (payload) => {
    return http({
        method: 'POST',
        data: payload,
        url: `${baseUrl}?service=treasure-hunt-location`
    })
}

export const getUserList = (params) => {
    return http({
        method: 'GET',
        url: `${baseUrl}/location/available-users?service=treasure-hunt-location&org_id=${params.org_id}`
    })
}

export const getSpecificQuest = (hunt_id) => {
    return http({
        method: 'GET',
        url: `${baseUrl}/hunt/${hunt_id}?service=treasure-hunt`
    })
}
export const getSpecificLocation = (location_id) => {
    return http({
        method: 'GET',
        url: `${baseUrl}/location/${location_id}?service=treasure-hunt-location`
    })
}

export const updateQuest = (hunt_id, params, payload) => {
    return http({
        method: 'PATCH',
        data: payload,
        url: `${baseUrl}/hunt/${hunt_id}?service=treasure-hunt&user_id=${params.user_id}&org_id=${params.org_id}`
    })
}
export const publishQuest = (hunt_id, payload) => {
    return http({
        method: 'POST',
        data: payload,
        url: `${baseUrl}/hunt/${hunt_id}/publish?service=treasure-hunt`
    })
}
export const deletePublishQuest = (hunt_id, org_id, user_id) => {
    return http({
        method: 'DELETE',
        url: `${baseUrl}/hunt/${hunt_id}/published-orgs/${org_id}?user_id=${user_id}&service=treasure-hunt`
    })
}
export const deleteQuest = (hunt_id, user_id) => {
    return http({
        method: 'DELETE',
        url: `${baseUrl}/hunt/${hunt_id}?service=treasure-hunt&user_id=${user_id}`
    })
}
export const deleteLocation = (location_id) => {
    return http({
        method: 'DELETE',
        url: `${baseUrl}/location/${location_id}?service=treasure-hunt-location`
    })
}

export const updateSpecificLocation = (location_id, payload) => {
    return http({
        method: 'PATCH',
        data: payload,
        url: `${baseUrl}/location/${location_id}?service=treasure-hunt-location`
    })
}

export const updateLocationGroup = (location_id, group_id, payload) => {
    return http({
        method: 'PATCH',
        data: payload,
        url: `${baseUrl}/location/${location_id}/groups/${group_id}?service=treasure-hunt-location`
    })
}

export const removeUserFromGroup = (location_id, group_id, user_id) => {
    return http({
        method: 'DELETE',
        url: `${baseUrl}/location/${location_id}/groups/${group_id}/users/${user_id}?service=treasure-hunt-location`
    })
}

export const regenerateQuiz = (hunt_id, stop_number, params) => {
    return http({
        method: 'POST',
        url: `${baseUrl}/hunt/${hunt_id}/stops/${stop_number}/regenerate?service=treasure-hunt&user_id=${params.user_id}&org_id=${params.org_id}`
    })
}

export const addEditors = (hunt_id, payload) => {
    return http({
        method: 'POST',
        data: payload,
        url: `${baseUrl}/hunt/${hunt_id}/editors?service=treasure-hunt`
    })
}

export const deleteEditor = (hunt_id, editor_id, user_id) => {
    return http({
        method: 'DELETE',
        url: `${baseUrl}/hunt/${hunt_id}/editors/${editor_id}?service=treasure-hunt&user_id=${user_id}`
    })
}